<template>
  <div>
    <div v-if="canShowContent">
      <Content
        v-for="banner in contents"
        :key="banner.id"
        model="announcement-banner"
        :content="banner"
        :api-key="apiKey"
        :data="{}"
        class="builder-announcement-banner"
      />
    </div>
  </div>
</template>

<script>
import { Content, fetchEntries, isPreviewing } from "@builder.io/sdk-vue";

const apiKey = import.meta.env.VITE_APP_BUILDER_API_KEY;

export default {
  name: "AnnouncementBar",
  components: {
    Content,
  },
  data: () => ({
    contents: [],
    canShowContent: false,
    modelName: "announcement-banner",
    apiKey,
    inprogress: false,
  }),
  methods: {
    async loadContent() {
      let vm = this;
      vm.inprogress = false;

      vm.contents = await fetchEntries({
        model: "announcement-banner",
        apiKey: vm.apiKey,
        query: {
          "data.visibility": "show", //custom field flag
        },
      });

      vm.inprogress = true;
      vm.canShowContent = vm.contents.length > 0 || isPreviewing();
    },
  },
  async mounted() {
    this.loadContent();
  },
};
</script>

<style lang="scss"></style>
